import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// 🧩 Import your icons
import RainWater from "../../assets/icons/Rain Water Harvesting-01.png";
import EfficientEnvelop from "../../assets/icons/Efficient Envelope-01.png";
import Ventilation from "../../assets/icons/MAXIMUM VENTILATION, AND CROSS BREEZE-01.png";
import Amenities from "../../assets/icons/Basic Amenities-01.png";
import VOC from "../../assets/icons/LOW VOC PAINTS & ADHESIVES-01.png";
import Renewable from "../../assets/icons/RENEWABLE ENERGY-01.png";
import WaterConservation from "../../assets/icons/WATER CONSERVATION-01.png";
import WaterManagement from "../../assets/icons/WATER MANAGEMENT-01.png";
import SolidWaste from "../../assets/icons/SOLID WASTE MANAGEMENT-01.png";

// ♻️ All cards data here
const cardData = [
  {
    icon: RainWater,
    title: "Rain Water Harvesting",
    desc: "The project captures rainwater to recharge groundwater and reduce municipal water use.",
  },
  {
    icon: EfficientEnvelop,
    title: "Efficient Envelope Design",
    desc: "Optimized building design helps reduce energy consumption.",
  },
  {
    icon: Ventilation,
    title: "Optimized Ventilation",
    desc: "Thoughtful ventilation supports airflow and cross-breeze for better indoor comfort.",
  },
  {
    icon: Amenities,
    title: "Basic Amenities",
    desc: "The project site is planned to reduce vehicle impact while providing essential amenities.",
  },
  {
    icon: VOC,
    title: "Low-VOC Materials",
    desc: "Paints and adhesives are used with a focus on healthier indoor air.",
  },
  {
    icon: Renewable,
    title: "Renewable energy",
    desc: "Renewable energy sources are utilized to support more sustainable project operations.",
  },
  {
    icon: WaterConservation,
    title: "Water Conservation",
    desc: "Water-conservation strategies are implemented to promote efficient and sustainable water use.",
  },
  {
    icon: WaterManagement,
    title: "Water Management",
    desc: "Low-flow fixtures and native-plant landscaping are designed to reduce on-site water use by 25%.",
  },
  {
    icon: SolidWaste,
    title: "Solid Waste management",
    desc: "Centralized waste collection supports flat-level dry and wet waste segregation.",
  },
]

export default function CardCarouselMobile() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="slider-container my-7 fade-edges">
      <Slider {...settings}>
        {cardData.map((card, index) => (
          <div key={index} className="px-3">
            <div
              className="rounded-[16px] p-2"
              style={{
                boxShadow: "inset 0px 0px 2px 1px rgba(0, 0, 0, 0.5)",
              }}
            >
              <div className="bg-[#fdf6f6] rounded-[14px] p-5 h-[260px]">
                <div className="bg-[#fff] w-16 h-16 flex justify-center items-center rounded-xl mb-4">
                  <img
                    src={card.icon}
                    alt={card.title}
                    className="w-auto h-auto"
                  />
                </div>
                <div>
                  <p className="text-[22px] font-inter mb-5 text-[#5e3920] text-left">
                    {card.title}
                  </p>
                  <p className="text-[#000000d9] text-[15px] leading-relaxed font-inter text-left w-[90%]">
                    {card.desc}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-3">
                  <div className="border border-[#0000001a] w-[80%]"></div>
                  <span className="w-4 h-4 rounded-full bg-[#0000001a]"></span>
                  <span className="w-4 h-4 rounded-full bg-[#0000001a]"></span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
